module.exports = __webpack_public_path__ + "img/quiz-time-out.8be21ad6.png";